import { ExploreProfileItemEntity } from "@modules/explore/entities/exploreEntity"
import { type ExploreProfileItemDto } from "@modules/explore/gateway/exploreDto"
import { type HUImage } from "@modules/types/imageTypes"

export class GetStreamUserEntity {
  id: string
  firstname: string
  lastname: string
  username: string
  avatar?: HUImage
  last_active?: string
  online?: boolean

  constructor(profileItem: GetStreamUserEntity) {
    this.id = profileItem.id
    this.firstname = profileItem.firstname
    this.lastname = profileItem.lastname
    this.username = profileItem.username
    this.avatar = profileItem.avatar
    this.last_active = profileItem.last_active
    this.online = profileItem.online
  }

  static fromDto(dto: ExploreProfileItemDto & { last_active?: string; online?: boolean }): GetStreamUserEntity {
    return new GetStreamUserEntity({
      ...ExploreProfileItemEntity.fromDto(dto),
      last_active: dto.last_active,
      online: dto.online,
    })
  }
}
